/* eslint-disable react/no-unstable-nested-components */
import React, { useState } from 'react';
import Grid from '@mui/material/Grid';
import TablePagination from '@mui/material/TablePagination';
import SideBarContainer from 'Containers/SideBarContainer';
import FilterContainer from 'Containers/FilterContainer';
import TableContainer from 'Containers/TableContainer';
import useTranslation from 'Hooks/useTranslation';
import Title from 'Components/Title';
import Search from 'Components/Search';
import BasicTableV2 from 'Components/BasicTableV2';
import DateRange from 'Components/DateRange';
import { EVENTS } from 'Constants/General';
import ExportExcel from 'Components/ExportToExcel';
import Dropdowns from './Components/DropDowns';
import useFetch from './Hooks/useFetch';
import useFetchAreas from './Hooks/useFetchAreas';
import useConfig from './Hooks/useConfig';
import Toogle from './Components/Toogle';
import usePagination from './Hooks/usePagination';

const { ON_KEY_PRESS } = EVENTS;

export default function Employee() {
  const { t2 } = useTranslation('DevelopmentPlan');
  const [isLoading, setIsLoading] = useState(true);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const {
    setTerminal,
    setDepartment,
    setJobTitle,
    employees,
    setLimit,
    setOffset,
    limit,
    count,
    setEmployee,
    page,
    setPage,
    isByUsers,
    setIsByUsers,
    courses,
    setCourse,
    dataToExport,
  } = useFetch(setIsLoading, startDate, endDate);

  const { allTerminals, allDepartments, allJobTitles, categories } = useFetchAreas();

  const titles = [t2('Terminal'), t2('Department'), t2('JobTitle')];
  const methods = [setTerminal, setDepartment, setJobTitle];
  const options = [allTerminals, allDepartments, allJobTitles];

  const { handleChangePage, handleChangeRowsPerPage } = usePagination({
    limit,
    setOffset,
    setPage,
    setLimit,
  });

  const {
    titleHighlighted,
    title,
    labels,
    searchPlaceholder,
    setData,
    thereIsComponent,
    tableHeaders,
    tableInformation,
    tableLimitColumns,
    display,
  } = useConfig({
    isByUsers,
    setEmployee,
    employees,
    setCourse,
    courses,
    categories,
  });

  function ToogleC() {
    return (
      <Grid item xs={4} md={1.5} style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Toogle onclick={setIsByUsers} value={isByUsers} />
      </Grid>
    );
  }

  return (
    <SideBarContainer>
      <Title
        title={t2('Title')}
        titleHighlighted={titleHighlighted}
        ExportToExcel={<ExportExcel headers={title} data={dataToExport} labels={labels} />}
      />
      <FilterContainer>
        <Grid item xs={6} md={2} style={{ paddingLeft: '0' }}>
          <Search placeholder={searchPlaceholder} eventType={ON_KEY_PRESS} setData={setData} />
        </Grid>
        <Grid item xs={6} md={3.5} style={{ display }}>
          <DateRange
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            setIsLoading={setIsLoading}
          />
        </Grid>
        <Grid item xs={8} md={5} style={{ display }}>
          <Dropdowns titles={titles} options={options} methods={methods} />
        </Grid>
        <ToogleC />
      </FilterContainer>

      <br />
      <br />
      <TableContainer>
        <BasicTableV2
          information={tableInformation}
          headers={tableHeaders}
          limitColumns={tableLimitColumns}
          thereIsComponent={thereIsComponent}
          isLoading={isLoading}
        >
          <TablePagination
            component="div"
            count={count}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={limit}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelRowsPerPage={t2('Pagination')}
          />
        </BasicTableV2>
      </TableContainer>
    </SideBarContainer>
  );
}
